import { css } from '@linaria/core';
import { styled } from '@linaria/react';

import { ANIMATION_DURATION } from './config';

export const AnimateMountUnmount = styled.div<{
  unmounting: boolean;
  delay?: number;
}>`
  transform: translateY(5rem);
  opacity: 0;

  animation-delay: ${({ delay = 0, unmounting }) =>
    unmounting ? '0ms' : `${delay}ms`};
`;

export const unmountClassName = css`
  @keyframes AnimateMountUnmount_unmount {
    from {
      transform: translateY(0);
      opacity: 1;
    }
    to {
      transform: translateY(5rem);
      opacity: 0;
    }
  }
  animation: AnimateMountUnmount_unmount ${ANIMATION_DURATION.unmount}ms
    ease-out forwards;
`;

export const mountClassName = css`
  @keyframes AnimateMountUnmount_mount {
    from {
      transform: translateY(5rem);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
  animation: AnimateMountUnmount_mount ${ANIMATION_DURATION.mount}ms ease-out
    forwards;
`;
